var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#546E7A",
    d: "M104,24H93.781c-2.773-4.766-7.875-8-13.781-8c0-8.836-7.164-16-16-16S48,7.164,48,16 c-5.906,0-11.008,3.234-13.783,8H24c-8.836,0-16,7.164-16,16v72c0,8.836,7.164,16,16,16h80c8.836,0,16-7.164,16-16V40 C120,31.164,112.836,24,104,24z M40,32c0-4.414,3.586-8,8-8h8v-8c0-4.414,3.586-8,8-8s8,3.586,8,8v8h8c4.414,0,8,3.586,8,8v8H40 V32z M96,48v56H32V48H96z M112,112c0,4.414-3.586,8-8,8H24c-4.414,0-8-3.586-8-8V40c0-4.414,3.586-8,8-8h8v8h-8v72h80V40h-8v-8h8 c4.414,0,8,3.586,8,8V112z M72,32v-8H56v8H72z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M88,56H40v8h48V56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M88,72H40v8h48V72z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M64,88H40v8h24V88z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseline);
export default __webpack_public_path__ + "static/media/baseline.c71ca0bdc27147d2b01542493856ee77.svg";
export { ForwardRef as ReactComponent };